import React from 'react'

const Cars = () => {
  return (
    <div>Cars</div>
  )
}

export default Cars